<template>
  <div class="h4-title-view">
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  name: "H4TitleView",
})
</script>

<!-- Style -->
<style lang="scss" scoped>
@import "@/styles/variables";

.h4-title-view {
  color: $title-default-color;
  text-align: left;
  font-weight: normal;
  font-size: 20px;
  line-height: 23px;
}
</style>
